import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { toBase64 } from "../../Services/commonHelper";
import { createProduct } from "../../Services/ProductService";

const AddProduct = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        name: "",
        title: "",
        description: "",
        overview: "",
        price: "",
        discount: "",
        discount_type: "",
        tax_percentage: "",
        configration_id: "",
        image: "",
        type: "exam",
        vendor: "brain_wonder",
        set_id: ""
    });
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();
    const [previewImage, setPreviewImage] = useState({
        icon: ""
    });
    const uploadLogoRef = useRef(null);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const redirect = (url) => {
        navigate(url, { state: reqData })
    };

    const handleImport = async (e, field) => {
        const file = e.target.files[0];
        e.target.value = "";
        if (file?.type?.includes("image/jpeg") || file?.type?.includes("image/png")) {
            let base64String = await toBase64(file);
            handleChange(field, base64String);
            setPreviewImage({ ...previewImage, [field]: URL?.createObjectURL(file) });
        } else {
            toast.error("Image must ba valid .jpeg file")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createProduct({ ...reqData, configration_id: reqData?.configration_id ? `${reqData?.configration_id}` : "" });
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    useEffect(() => {
        if (data?.data) {
            const { id, name, title, description, overview, price, discount, discount_type, tax_percentage, configration_id, image, vendor, type, set_id } = data?.data;
            setReqData({ id, name, title, description, overview, price, discount, discount_type, tax_percentage, configration_id, image, vendor, type, set_id });
        }
    }, []);

    return (
        <div
            className="modal modal-fullscreen custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add Product" : "Edit Product"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                required
                                                value={reqData?.name}
                                                onChange={(e) => handleChange("name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Title</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Ttitle"
                                                required
                                                value={reqData?.title}
                                                onChange={(e) => handleChange("title", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Overview</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Overview"
                                                required
                                                value={reqData?.overview}
                                                onChange={(e) => handleChange("overview", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Price</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Price"
                                                required
                                                value={reqData?.price}
                                                onChange={(e) => handleChange("price", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Discount (%)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Discount (%)"
                                                required
                                                value={reqData?.discount}
                                                onChange={(e) => handleChange("discount", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Discount Type</label>
                                            <select required value={reqData?.discount_type} onChange={(e) => handleChange("discount_type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Select</option>
                                                <option value={"flat"}>Flat</option>
                                                <option value={"percentage"}>Percentage</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Tax Percentage (%)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Tax Percentage (%)"
                                                required
                                                value={reqData?.tax_percentage}
                                                onChange={(e) => handleChange("tax_percentage", e?.target?.value)}
                                            />
                                        </div>
                                        {/* <div className="form-group">
                                            <label>Configuration ID</label>
                                            <select required value={reqData?.configration_id} onChange={(e) => handleChange("configration_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option value="">Select</option>
                                                <option value={"100"}>Intelligences</option>
                                                <option value={"101"}>Learning & Productivity</option>
                                                <option value={"103"}>Learning & Productivity College</option>
                                                <option value={"104"}>Personality</option>
                                                <option value={"1700"}>Skills</option>
                                            </select>
                                        </div> */}
                                        <div className="form-group">
                                            <label>Configuration ID</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Configuration ID"
                                                required
                                                value={reqData?.configration_id}
                                                onChange={(e) => handleChange("configration_id", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Vendor</label>
                                            <select required value={reqData?.vendor} onChange={(e) => handleChange("vendor", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected value={"key_to_success"}>Barinwonder</option>
                                                <option selected value={"brain_wonder"}>Key To Success</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Type</label>
                                            <select required value={reqData?.type} onChange={(e) => handleChange("type", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected value={"exam"}>Exam</option>
                                            </select>
                                        </div>
                                         <div className="form-group">
                                            <label>Set ID</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Set ID"
                                                required
                                                value={reqData?.set_id}
                                                onChange={(e) => handleChange("set_id", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Description"
                                                required
                                                value={reqData?.description}
                                                onChange={(e) => handleChange("description", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="d-flex bank-details-btn" style={{ marginTop: "40px" }}>
                                            <div>
                                                <button onClick={(e) => { e.preventDefault(); uploadLogoRef?.current?.click() }} className={`btn bank-save-btn`}>
                                                    {reqData?.image ? "Change" : "Add Image"}
                                                </button>
                                            </div>
                                            {Boolean(previewImage?.image || reqData?.image) && <img
                                                width={75}
                                                class="mx-3 img-thumbnail"
                                                alt="Icon Image"
                                                src={previewImage?.image ? previewImage?.image : reqData?.image}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="bank-details-btn">
                                    <button
                                        data-bs-dismiss="modal"
                                        className="btn bank-cancel-btn me-2"
                                        onClick={() => onClose()}
                                        disabled={loader}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn bank-save-btn me-2"
                                        disabled={loader}
                                    >
                                        {loader ? "Loading..." : "Save"}
                                    </button>
                                    {reqData?.id &&
                                        <>
                                            <button
                                                className="btn bank-save-btn me-2"
                                                disabled={loader}
                                                onClick={() => redirect("/product/benefits")}
                                            >
                                                Benefits
                                            </button>
                                            <button
                                                className="btn bank-save-btn me-2"
                                                disabled={loader}
                                                onClick={() => redirect("/product/instructions")}
                                            >
                                                Instructions
                                            </button>
                                            <button
                                                className="btn bank-save-btn me-2"
                                                disabled={loader}
                                                onClick={() => redirect("/product/gallery")}
                                            >
                                                Gallery
                                            </button>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <input hidden ref={uploadLogoRef} type="file" name="upload" id="upload" onChange={(e) => handleImport(e, "image")} />
        </div>
    );
};

export default AddProduct;